import { useEffect } from "react";
import { useForm } from "../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../controls/Input";

import ImportMediaDropzone from "../../importMedia/ImportMediaDropzone";
import { classNames } from "../../../shared/utility";
import SelectMenu from "../../controls/SelectMenu";

const initialFValues = {
  name: "",
  documentLink: "",
};

export default function AssignDocumentForm(props) {
  const {
    employeesDropdownOptions,
    hideName,
    index,
    document,
    setOpen,
    actionCall,
    isEdit,
  } = props;

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEdit) {
      actionCall(values, index);
    } else {
      actionCall(values);
    }
  };

  useEffect(() => {
    if (isEdit) {
      setValues(document);
    }
  }, [document, setValues]);

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {isEdit
                ? `Submit document for ${document.fname} ${document.lname}`
                : "Assign document"}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div>
            <div className={classNames(isEdit ? "hidden" : null)}>
              <SelectMenu
                handleInputChange={handleInputChange}
                name="employee_id"
                options={employeesDropdownOptions}
                width="w-48"
                selectedOptionValue={employeesDropdownOptions[0].value}
              />
            </div>
            <div
              className={classNames(
                hideName ? "hidden" : null,
                "mt-3 grid grid-cols-2 gap-2"
              )}
            >
              <div className="grid-col-2">
                <Input
                  label="Document Name"
                  name="name"
                  onChange={handleInputChange}
                  value={values.name}
                  labelOn={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>
            </div>
            <div className="mt-3 grid grid-cols-2 gap-2">
              <div className="grid-col-2">
                <div className="flex space-x-2">
                  <label
                    htmlFor="document1"
                    className="block text-sm font-medium text-gray-900"
                  >
                    Document
                  </label>
                </div>
                <ImportMediaDropzone
                  fileName="document1"
                  handleInputChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
          // onClick={() => setOpen({ childComponent: null, open: false })}
          onClick={handleSubmit}
        >
          {isEdit ? "Submit" : "Assign"}
        </button>
      </div>
    </div>
  );
}
